import React from 'react';
import BaseVariables from '..';

function PhysicianVariables() {
    return (
        <BaseVariables variableGroup="Physician"/>
    );
}

export default PhysicianVariables;
